import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { routes } from './reports.router'
import { FormsModule } from '@angular/forms'
import { PortalCommonModule } from '../common/portal-common.module'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { ValidationModule } from '../validations/validation.module'
import { HttpRequestInterceptor } from '../interceptor/http-request-interceptor'
import { MyClientsComponent } from './components/my-clients/my-clients.component'
import { ReportsLayoutComponent } from './components/layout/reports-layout.component'
import { ReportsGateway } from './gatewasys/reports.gateway'
import { NetworkReportsGateway } from './gatewasys/network-reports.gateway'
import { FulfillmentGateway } from '../fulfillment/gateways/fulfillment.gateway'
import { NetworkFulfillmentGateway } from '../fulfillment/gateways/network-fulfillment.gateway'
import { ExcelService } from './excel.service'
import { EnrollmentsCountComponent } from './components/my-clients/enrollments-count.component'
import { EnrollmentsSummaryComponent } from './components/my-clients/enrollments-summary.component'
import { ExternalTrainingComponent } from './components/ExternalTraining/external-training.component'
import { MultiSelectOrgSample } from './components/my-clients/multiselect-org-sample'
import { UserTypeGateway } from '../user-management/gateways/user-type-gateway'
import { NetworkUserTypeGateway } from '../user-management/gateways/network-user-type-gateway'
import { OrgLevelGateway } from '../org-management/gateways/organization-gateway'
import { NetworkOrganizationGateway } from '../org-management/gateways/network-organization-gateway'
import { EnrollmentSearchComponent } from './components/enrollment-search/enrollment-search.component'
import { EnrollmentJQGridData } from './components/enrollment-search/enrollment-JQGrid.component'
import { IsSuperAdminOrGuruAdminGuard } from '../auth/is-super-admin-or-guru-admin-guard'
import { EnrollmentGateway } from '../enrollment/gateways/enrollment-gateway'
import { NetworkEnrollementGateway } from '../enrollment/gateways/network-enrollment-gateway'
import { TempidcardGateway } from '../tempID-card/gateways/tempID-gateway'
import { NetworktempidcardGateway } from '../tempID-card/gateways/network-tempID-gateway'
import { EnrollmentDetailsComponent } from './components/my-clients/enrollment-details.component'
import { CommonGateway } from '../common/gateways/common-gateway'
import { NetworkCommonGateway } from '../common/gateways/network-common-gateway'
import { MedicareIDSearchComponent } from './components/clients-report/medicareid-search.component'
import { UserGateway } from '../user-management/gateways/user-gateway'
import { NetworkUserGateway } from '../user-management/gateways/network-user-gateway'

import { ClientsReportComponent } from './components/clients-report/clients-report.component'
import { OrgSelectorComponent } from './components/clients-report/org-selector.component'
import { OrgListComponent } from './components/clients-report/org-list.component'
import { OrgListContainerComponent } from './components/clients-report/org-list-container.component'
import { OrgSearchComponent } from './components/clients-report/org-search.component'
import { OrganizationDataGateway } from './gatewasys/organization-data.gateway'
import { NetworkOrganizationDataGateway } from './gatewasys/network-organization-data.gateway'
import { EnrollmentCountsReportComponent } from './components/clients-report/enrollment-counts-report.component'
import { EnrollmentSummaryReportComponent } from './components/clients-report/enrollment-summary-report.component'
import { EnrollmentDetailsReportComponent } from './components/clients-report/enrollment-details-report.component'
import { OrgSortByPipe } from './components/clients-report/org-sort-pipe-by'

import { NEJEClientsReportComponent } from './components/clients-report/neje/clients-report.component'
import { NEJEEnrollmentCountsReportComponent } from './components/clients-report/neje/enrollment-counts-report.component'
import { NEJEEnrollmentSummaryReportComponent } from './components/clients-report/neje/enrollment-summary-report.component'
import { NEJEEnrollmentDetailsReportComponent } from './components/clients-report/neje/enrollment-details-report.component'
import { NEJEMedicareIDSearchComponent } from './components/clients-report/neje/medicareid-search.component'

import { NewUsersAddedComponent } from './components/newusers-added/newusers-added.component'
import { UsersInactiveComponent } from './components/Users-Inactive/users-inactive.component'
import { UserProfileComponent } from './components/User-Profile/user-profile.component'

import { PWClientsReportComponent } from './components/pwmyclient/pwclients-report.component'
import { PWEnrollmentCountsReportComponent } from './components/pwmyclient/pwenrollment-counts-report.component'
import { PWEnrollmentSummaryReportComponent } from './components/pwmyclient/pwenrollment-summary-report.component'
import { PWEnrollmentDetailsReportComponent } from './components/pwmyclient/pwenrollment-details-report.component'
import { PWMedicareIDSearchComponent } from './components/pwmyclient/pwmedicareid-search.component'
import { PWOrgSelectorComponent } from './components/pwmyclient/pworg-selector.component'
import { PWOrgListComponent } from './components/pwmyclient/pworg-list.component'
import { PWOrgListContainerComponent } from './components/pwmyclient/pworg-list-container.component'
import { PWOrgSearchComponent } from './components/pwmyclient/pworg-search.component'
import { PWOrgSortByPipe } from './components/pwmyclient/pworg-sort-pipe-by'

import { SsMyClientsComponent } from './components/ss-my-clients/ss-my-clients.component'
import { SSMyClientsSummaryComponent } from './components/ss-my-clients/ss-my-clients-summary.component'
import { SSMyClientsDetailsComponent } from './components/ss-my-clients/ss-my-clients-details.component'

@NgModule({ declarations: [
        OrgSortByPipe,
        ReportsLayoutComponent,
        MyClientsComponent,
        MultiSelectOrgSample,
        EnrollmentsCountComponent,
        EnrollmentsSummaryComponent,
        EnrollmentSearchComponent,
        EnrollmentJQGridData,
        EnrollmentDetailsComponent,
        MedicareIDSearchComponent,
        ExternalTrainingComponent,
        ClientsReportComponent,
        OrgSelectorComponent,
        OrgSearchComponent,
        OrgListComponent,
        OrgListContainerComponent,
        EnrollmentCountsReportComponent,
        EnrollmentSummaryReportComponent,
        EnrollmentDetailsReportComponent,
        NEJEClientsReportComponent,
        NEJEEnrollmentCountsReportComponent,
        NEJEEnrollmentSummaryReportComponent,
        NEJEEnrollmentDetailsReportComponent,
        NEJEMedicareIDSearchComponent,
        UsersInactiveComponent,
        UserProfileComponent,
        NewUsersAddedComponent,
        PWClientsReportComponent,
        PWEnrollmentCountsReportComponent,
        PWEnrollmentSummaryReportComponent,
        PWEnrollmentDetailsReportComponent,
        PWMedicareIDSearchComponent,
        PWOrgSelectorComponent,
        PWOrgListComponent,
        PWOrgListContainerComponent,
        PWOrgSearchComponent,
        PWOrgSortByPipe,
        SsMyClientsComponent,
        SSMyClientsSummaryComponent,
        SSMyClientsDetailsComponent
    ],
    exports: [
        OrgListContainerComponent,
        OrgSearchComponent
    ], imports: [FormsModule,
        CommonModule,
        PortalCommonModule,
        RouterModule.forChild(routes),
        ValidationModule], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
        { provide: ReportsGateway, useClass: NetworkReportsGateway },
        { provide: UserTypeGateway, useClass: NetworkUserTypeGateway },
        { provide: OrgLevelGateway, useClass: NetworkOrganizationGateway },
        { provide: EnrollmentGateway, useClass: NetworkEnrollementGateway },
        { provide: TempidcardGateway, useClass: NetworktempidcardGateway },
        { provide: CommonGateway, useClass: NetworkCommonGateway },
        { provide: FulfillmentGateway, useClass: NetworkFulfillmentGateway },
        { provide: UserGateway, useClass: NetworkUserGateway },
        { provide: OrganizationDataGateway, useClass: NetworkOrganizationDataGateway },
        ExcelService,
        IsSuperAdminOrGuruAdminGuard,
        provideHttpClient(withInterceptorsFromDi())
    ] })

export class ReportsModule { }
